<h1>
    Reset Token?
</h1>
<p>
    Do you really want to reset token of application «{{application.name}}»?
</p>
<div class="buttons">
    <button class="default" (click)="restore()">
        Reset
    </button>
    <button class="outline" (click)="cancel()">
        Cancel
    </button>
</div>
<ui-loading *ngIf="isLoading"></ui-loading>